function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import MuiCheckIcon from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { GiveawayProductChoice } from 'swag-common/constants/giveaway.constants';
import { GiveawayProductCard } from '../giveaway-product-card';
import { ImagePopup } from '../../popups/image-popup';
import classes from './giveaway-products-list.scss';
const CheckIcon = withStyles({
  root: {
    color: '#ffffff'
  }
})(MuiCheckIcon);
export class GiveawayProductsListComponent extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleProductSelect", activeProduct => {
      const {
        activeProducts,
        productQuantity,
        setGiveawayLandingActiveItem,
        removeGiveawayLandingActiveItem
      } = this.props;
      if (!activeProduct.available) {
        return;
      }
      if (activeProducts.includes(activeProduct._id)) {
        removeGiveawayLandingActiveItem(activeProduct._id);
      } else if (activeProducts.length < productQuantity) {
        setGiveawayLandingActiveItem(activeProduct);
      } else if (productQuantity === 1) {
        removeGiveawayLandingActiveItem(activeProducts[0]);
        setGiveawayLandingActiveItem(activeProduct);
      }
    });
    _defineProperty(this, "renderContent", () => {
      const {
        productChoice,
        productQuantity
      } = this.props;
      switch (productChoice) {
        case GiveawayProductChoice.all:
          {
            return this.choiceAllProducts();
          }
        case GiveawayProductChoice.choice:
          {
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
              className: classes.choiceText
            }, "Make your selection (Choose up to ", productQuantity, "):"), this.smallScreen(), this.bigScreen());
          }
        default:
          return null;
      }
    });
    _defineProperty(this, "smallScreen", () => {
      const {
        products,
        giveawayColor,
        productChoice,
        activeProducts,
        isReserve
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.smallScreen
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.productSelect
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.choiceImages
      }, products.map(product => {
        const {
          defaultImage,
          name,
          _id,
          available
        } = product;
        return /*#__PURE__*/React.createElement("div", {
          key: _id,
          className: classNames(classes.choiceImageWrapper, {
            [classes.choiceImageWrapperNotAvailable]: !available
          }),
          onClick: () => this.handleProductSelect(product),
          style: activeProducts.includes(String(_id)) ? {
            borderColor: giveawayColor
          } : {}
        }, /*#__PURE__*/React.createElement("img", {
          src: defaultImage,
          alt: name,
          key: String(_id)
        }), activeProducts.includes(String(_id)) && available && /*#__PURE__*/React.createElement("div", {
          className: classes.circle,
          style: {
            background: giveawayColor
          }
        }, /*#__PURE__*/React.createElement(CheckIcon, null)));
      }))), activeProducts && activeProducts.map(product => /*#__PURE__*/React.createElement(GiveawayProductCard, {
        key: product,
        product: products.find(({
          _id
        }) => String(_id) === product),
        primaryColor: giveawayColor,
        productChoice: productChoice,
        showSelection: this.isShowSelection(false, products.find(({
          _id
        }) => String(_id) === product)),
        selectable: false,
        isReserve: isReserve
      })));
    });
    _defineProperty(this, "bigScreen", () => {
      const {
        products,
        giveawayColor,
        productChoice,
        productQuantity,
        activeProducts,
        isReserve
      } = this.props;
      const isSelectedMaxAmountOfProducts = activeProducts.length >= productQuantity;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.bigScreen
      }, products.map(product => {
        const isDefaultCursorForProduct = isSelectedMaxAmountOfProducts && !activeProducts.includes(product._id);
        return /*#__PURE__*/React.createElement("div", {
          key: product._id,
          className: classNames(classes.selectableProduct, {
            [classes.selectableProductNotAvailable]: !product.available,
            [classes.defaultCursor]: isDefaultCursorForProduct
          }),
          "data-product-id": product._id
        }, product.available && /*#__PURE__*/React.createElement("div", {
          className: classNames(classes.iconWrapper, {
            [classes.hiddenIcon]: !activeProducts.includes(String(product._id)) && activeProducts.length >= productQuantity && productQuantity !== 1
          }),
          onClick: () => this.handleProductSelect(product),
          style: activeProducts.includes(String(product._id)) ? {
            borderColor: giveawayColor,
            backgroundColor: giveawayColor
          } : {}
        }, activeProducts.includes(String(product._id)) && /*#__PURE__*/React.createElement(CheckIcon, null)), /*#__PURE__*/React.createElement(GiveawayProductCard, {
          product: product,
          primaryColor: giveawayColor,
          productChoice: productChoice,
          key: product._id,
          selectable: true,
          isReserve: isReserve,
          showSelection: this.isShowSelection(true, product),
          onCardClick: this.handleProductSelect
        }));
      }));
    });
    _defineProperty(this, "choiceAllProducts", () => {
      const {
        products,
        giveawayColor,
        productChoice,
        isReserve
      } = this.props;
      return /*#__PURE__*/React.createElement(React.Fragment, null, products.map(product => /*#__PURE__*/React.createElement(GiveawayProductCard, {
        product: product,
        showSelection: this.isShowSelection(false, product),
        productChoice: productChoice,
        primaryColor: giveawayColor,
        key: product._id,
        selectable: false,
        isReserve: isReserve
      })));
    });
    _defineProperty(this, "isShowSelection", (selectable, product) => {
      const {
        activeProducts
      } = this.props;
      if (!product) {
        return false;
      }
      return !selectable || selectable && activeProducts.includes(String(product._id));
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderContent(), /*#__PURE__*/React.createElement(ImagePopup, null));
  }
}